import { router } from "./router";
import store from "./store";
import { dialog } from "./components";

export default {
  router,
  store,
  dialog
};
